var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 60,
    viewBox: "0 0 81 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0931 12.84C80.6431 8.9955 76.0097 7.82341 72.8999 10.1497L47.1605 29.4038C42.9418 32.5575 37.0993 32.3663 33.1018 28.935L9.33444 8.56585C7.9232 7.35638 5.73394 7.81997 5.47187 9.66002C4.12562 19.0838 1.61306 36.6563 0.11306 47.16C-0.34819 50.3888 0.615598 53.6588 2.7531 56.1225C4.88685 58.5863 7.98807 60 11.2506 60H63.5969C69.1956 60 73.943 55.8825 74.7343 50.34L80.0931 12.84ZM16.6093 0C14.4042 0 13.9329 2.63221 15.6072 4.06716L37.9805 23.2425C39.3155 24.3862 41.2618 24.45 42.668 23.3962L69.6811 3.19165C71.1049 2.12672 70.7335 0 68.9556 0H16.6093Z",
    fill: "url(#paint0_linear_949_89)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_949_89",
    x1: 86.484,
    y1: -5.88785,
    x2: 53.272,
    y2: 78.5668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030AC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.80fccaf1d13d53f717706b73483cb403.svg";
export { ForwardRef as ReactComponent };